const isWithGetSelection = (node: any): node is { getSelection: () => Selection } => {
    return 'getSelection' in node;
};

export const getShadowDomSelection = (root: ShadowRoot): Selection | undefined => {
    return isWithGetSelection(root) ? root.getSelection() : undefined;
};
